// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__Cs3U4","opened":"styles_opened__W7cnQ","menu":"styles_menu__AKF4Z","card":"styles_card__RiBZM","item":"styles_item__EB3It","active":"styles_active__-roV8"};